// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RheinWeinWelt-badge-wrapper {
    display: block;
    transition: transform 0.3s;
}
.RheinWeinWelt-badge-wrapper a:hover {
    transform: scale(1.025);
}

.RheinWeinWelt-badge-wrapper a {
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 100px;
    margin-right: 20px;
}

.RheinWeinWelt-badge-content {
    display: flex;
    align-items: center;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(217, 185, 146, 0.7);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(217, 185, 146, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(217, 185, 146, 0);
    }
}

.RheinWeinWelt-text {
    background-color: #d9b992;
    color: #000;
    font-weight: bold;
    align-self: center;
    padding: 12px 30px 15px 15px;
    margin-right: -20px;
    max-width: 185px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    font-family: 'Roboto', Arial, sans-serif;
    font-size: 16px;
    line-height: 26px;
    animation: pulse 2.5s infinite;
}


.RheinWeinWelt-image img {
    display: block;
    width: auto;
    height: 130px;
    border:#d9b992 solid 8px;
    border-radius:50%; 
}
@media screen and (max-width: 600px) {
    .RheinWeinWelt-image img {
        height: 100px; 
        border:#d9b992 solid 6px; 
    }
    .RheinWeinWelt-text { 
        max-width: 170px;
        font-size: 15px;
        line-height: 24px;
        padding: 12px 25px 12px 12px;
    }
    .RheinWeinWelt-badge-wrapper a {
        margin-top: 80px;
        margin-right: 10px;
    }
  }


@media screen and (max-width: 450px) {
    .RheinWeinWelt-image img {
        height: 80px; 
        border:#d9b992 solid 5px; 
    }
    .RheinWeinWelt-text { 
        padding: 9px 15px 9px 9px;
        margin-right: -20px;
        max-width: 155px;
        font-size: 14px;
        line-height: 20px;
    }
    .RheinWeinWelt-badge-wrapper a {
        margin-top: 80px;
        margin-right: 10px;
    }
  }
  


`, "",{"version":3,"sources":["webpack://./src/container/RheinWeinWeltBadge/rheinWeinWeltBadge.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,4CAA4C;IAChD;IACA;QACI,6CAA6C;IACjD;IACA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI;QACI,aAAa;QACb,wBAAwB;IAC5B;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,4BAA4B;IAChC;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;EACF;;;AAGF;IACI;QACI,YAAY;QACZ,wBAAwB;IAC5B;IACA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;EACF","sourcesContent":[".RheinWeinWelt-badge-wrapper {\n    display: block;\n    transition: transform 0.3s;\n}\n.RheinWeinWelt-badge-wrapper a:hover {\n    transform: scale(1.025);\n}\n\n.RheinWeinWelt-badge-wrapper a {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-top: 100px;\n    margin-right: 20px;\n}\n\n.RheinWeinWelt-badge-content {\n    display: flex;\n    align-items: center;\n}\n\n@keyframes pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(217, 185, 146, 0.7);\n    }\n    70% {\n        box-shadow: 0 0 0 10px rgba(217, 185, 146, 0);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgba(217, 185, 146, 0);\n    }\n}\n\n.RheinWeinWelt-text {\n    background-color: #d9b992;\n    color: #000;\n    font-weight: bold;\n    align-self: center;\n    padding: 12px 30px 15px 15px;\n    margin-right: -20px;\n    max-width: 185px;\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    font-family: 'Roboto', Arial, sans-serif;\n    font-size: 16px;\n    line-height: 26px;\n    animation: pulse 2.5s infinite;\n}\n\n\n.RheinWeinWelt-image img {\n    display: block;\n    width: auto;\n    height: 130px;\n    border:#d9b992 solid 8px;\n    border-radius:50%; \n}\n@media screen and (max-width: 600px) {\n    .RheinWeinWelt-image img {\n        height: 100px; \n        border:#d9b992 solid 6px; \n    }\n    .RheinWeinWelt-text { \n        max-width: 170px;\n        font-size: 15px;\n        line-height: 24px;\n        padding: 12px 25px 12px 12px;\n    }\n    .RheinWeinWelt-badge-wrapper a {\n        margin-top: 80px;\n        margin-right: 10px;\n    }\n  }\n\n\n@media screen and (max-width: 450px) {\n    .RheinWeinWelt-image img {\n        height: 80px; \n        border:#d9b992 solid 5px; \n    }\n    .RheinWeinWelt-text { \n        padding: 9px 15px 9px 9px;\n        margin-right: -20px;\n        max-width: 155px;\n        font-size: 14px;\n        line-height: 20px;\n    }\n    .RheinWeinWelt-badge-wrapper a {\n        margin-top: 80px;\n        margin-right: 10px;\n    }\n  }\n  \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
